/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_A21Inputs */

const en_cv_extract_form_enum_a21 = /** @type {(inputs: Cv_Extract_Form_Enum_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A2 - Elementary`)
};

const de_cv_extract_form_enum_a21 = /** @type {(inputs: Cv_Extract_Form_Enum_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A2 - Grundlegende Kenntnisse`)
};

/**
* | output |
* | --- |
* | "A2 - Elementary" |
*
* @param {Cv_Extract_Form_Enum_A21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_a21 = /** @type {((inputs?: Cv_Extract_Form_Enum_A21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_A21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_a21(inputs)
	return en_cv_extract_form_enum_a21(inputs)
});
export { cv_extract_form_enum_a21 as "cv_extract_form_enum_A2" }